import { useState, useEffect, useCallback } from 'react';

const useFetchHiringReviews = (hiringId) => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchReviews = useCallback(async () => {
    if (!hiringId) {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_STAGING_URL}/api/reviews/hiring/${hiringId}`,
        {
          method: 'GET',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      if (!response.ok) {
        throw new Error('Failed to fetch reviews');
      }

      const data = await response.json();
      if (data.success) {
        setReviews(data.data || []);
      } else {
        setReviews([]);
      }
      setError(null);
    } catch (err) {
      console.error('Error fetching hiring reviews:', err);
      setError(err.message);
      setReviews([]);
    } finally {
      setLoading(false);
    }
  }, [hiringId]);

  useEffect(() => {
    fetchReviews();
  }, [fetchReviews]);

  return { reviews, loading, error, refreshReviews: fetchReviews };
};

export default useFetchHiringReviews;

